import React from "react";

import { navigation } from "../data";

const NavMobile = ({ handleNav }) => {
  return (
    <div className="bg-[#EAE9E5] w-full h-full shadow-2xl">
      <ul className="text-center h-full flex flex-col items-center justify-center gap-y-6 ">
        {navigation.map((item, index) => {
          return (
            <li key={index} onClick={() => handleNav()}>
              <a
                className="text-xl font-medium capitalize"
                href={`#${item.href}`}
              >
                {item.href}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default NavMobile;
